module.exports = __webpack_public_path__ + "img/logo.b444764f.png";